export enum FieldSortingType {
	Ascending = 1,
	Descending = 2,
	Custom = 3
}